import HTTP from '../common/http-common';
const END_POINT = '/stockparts/';

const getStockParts = (id) => HTTP.get(END_POINT + id);
const listDetailByJobNo = (jobNo, branchCode) => HTTP.get(END_POINT + "listDetailByJobNo", {
    cache: false,
    params: {
        jobNo: jobNo,
        branchCode: branchCode
    }
});

const listStockParts = (branchCode, searchType, searchValue) => HTTP.get(END_POINT + branchCode + "/" + searchType + "/" + searchValue);
const listStockPartsByReceiveNo = (dateFrom, dateTo, receiveNo, branchCode) => HTTP.get(END_POINT + "list", {
    cache: false,
    params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        receiveNo: receiveNo,
        branchCode: branchCode
    }
});

const insertStockParts = (data) => HTTP.post(END_POINT + "insert", {
    branchCode: data.branchCode,
    receiveNo: data.receiveNo,
    docDate: data.docDate,
    receiveDate: data.receiveDate,
    jobNo: data.jobNo,
    percentDiscount: data.percentDiscount,
    receiver: data.receiver,
    details: data.details
});

const deleteDetailStock = (id, detailId) => HTTP.get(END_POINT + "delete/" + id + "/" + detailId);

const deleteStockParts = (id) => HTTP.get(END_POINT + "delete/" + id);

const existReceiveNo = (receiveNo, branchCode) => HTTP.get(END_POINT + "exist", {
    params: {
        receiveNo: receiveNo,
        branchCode: branchCode
    }
});

const updateJobNo = (data) => HTTP.post(END_POINT + "update", {
    jobNo: data.jobNo,
    branchCode: data.branchCode,
    receivePartsId: data.receivePartsId
});

export {
    updateJobNo,
    getStockParts,
    listDetailByJobNo,
    listStockParts,
    listStockPartsByReceiveNo,
    insertStockParts,
    deleteDetailStock,
    existReceiveNo,
    deleteStockParts
}